<template>
    <div class="row">
        <h3>Processing message from I-Akaun</h3>    
    </div> 
</template>
<script>

import store from '../store';
import {
  Loading,
  QSpinnerHourglass,
} from 'quasar'
export default {
  name: 'Transact',
  components:{

  },data(){
    return{}
  }
  ,  mounted(){
      Loading.show({
        spinner: QSpinnerHourglass,
          message: "Processing message from I-Akaun",
          messageColor: "white",
          spinnerSize: 90, // in pixels
          spinnerColor: "blue",
          customClass : 'bg-white'
        });
  }
}
</script>